import { z } from 'zod';

export enum AlertStatus {
  CRITICAL = 'Critical',
  TRIPPED = 'Tripped',
  WARNING = 'Warning',
  INFO = 'Info',
  OK = 'OK',
  // NO_DATA = 'No_Data',  // TODO: Add support for "No Data" status
}

export const AlertStatusSchema = z.nativeEnum(AlertStatus);
